export default __webpack_public_path__ + "media/images/icons/pagination-597ca6415b3b1546ed248d6d7f90796c.svg";